import { z } from 'zod';

const emailMsg = 'Informe um e-mail válido';
const passwordMsg = 'Senha deve ter no mínimo 8 caracteres';

const strongPassword = z
  .string()
  .min(8, passwordMsg)
  .max(128, 'Senha deve ter no máximo 128 caracteres')
  .regex(/[A-Z]/, 'Senha deve ter ao menos 1 letra maiúscula')
  .regex(/[a-z]/, 'Senha deve ter ao menos 1 letra minúscula')
  .regex(/[0-9]/, 'Senha deve ter ao menos 1 dígito');

export const loginSchema = z.object({
  email: z.string({ message: emailMsg }).trim().toLowerCase().email(emailMsg),
  password: z.string().min(8, passwordMsg),
});
export type LoginInput = z.infer<typeof loginSchema>;

export const signupSchema = z
  .object({
    name: z.string().trim().min(2, 'Informe seu nome'),
    email: z.string().trim().toLowerCase().email(emailMsg),
    password: strongPassword,
    confirmPassword: z.string(),
    acceptTerms: z.literal(true, { message: 'Você precisa aceitar os termos' }),
  })
  .refine((data) => data.password === data.confirmPassword, {
    path: ['confirmPassword'],
    message: 'As senhas não coincidem',
  });
export type SignupInput = z.infer<typeof signupSchema>;

export const forgotSchema = z.object({
  email: z.string().trim().toLowerCase().email(emailMsg),
});
export type ForgotInput = z.infer<typeof forgotSchema>;

export const resetSchema = z
  .object({
    token: z.string().min(1, 'Token inválido'),
    password: strongPassword,
    confirmPassword: z.string(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    path: ['confirmPassword'],
    message: 'As senhas não coincidem',
  });
export type ResetInput = z.infer<typeof resetSchema>;

export const otpSchema = z.object({
  code: z.string().regex(/^\d{6}$/, 'Código deve ter 6 dígitos'),
});
export type OtpInput = z.infer<typeof otpSchema>;
